import type { Theme } from '@personalizehq/schemas/ir';

// The app theme is NULL until first written — the API invents no default, correctly (a token
// dictionary is the customer's design language, not ours). But `createDoc(theme)` needs one, so the
// dashboard ships this and writes it on first use.
//
// Two laws are visible in the shape and are not negotiable:
//   - every colour is a light/dark PAIR (a raw hex has no dark variant — SPEC §4);
//   - fonts are BUNDLED, never system. `family` here is a placeholder until the author uploads a
//     font asset and the token gets a `src`. Android ships no Arial and silently falls back to
//     Roboto, which would end line_count as an exact conformance gate forever (SPEC §4.1).
export const SEED_THEME: Theme = {
  colors: {
    'color.bg': { light: '#ffffff', dark: '#18181b' },
    'color.surface': { light: '#f4f4f5', dark: '#27272a' },
    'color.text': { light: '#18181b', dark: '#fafafa' },
    'color.muted': { light: '#71717a', dark: '#a1a1aa' },
    'color.primary': { light: '#4f46e5', dark: '#818cf8' },
    'color.on_primary': { light: '#ffffff', dark: '#0b0b0f' },
  },
  fonts: {
    'font.title': { family: 'Inter', size: 24, weight: 700, line_height: 1.25, max_scale: 1.4 },
    'font.body': { family: 'Inter', size: 16, weight: 400, line_height: 1.5, max_scale: 1.6 },
    'font.caption': { family: 'Inter', size: 13, weight: 400, line_height: 1.4, max_scale: 1.6 },
    'font.button': { family: 'Inter', size: 16, weight: 600, line_height: 1.2, max_scale: 1.4 },
  },
  buttons: {
    primary: {
      bg: 'color.primary',
      fg: 'color.on_primary',
      radius: 10,
      padding: { top: 12, end: 20, bottom: 12, start: 20 },
    },
    secondary: {
      bg: 'color.surface',
      fg: 'color.text',
      radius: 10,
      padding: { top: 12, end: 20, bottom: 12, start: 20 },
    },
    // `bg: null` is a real variant, not an omission — a text-only button.
    ghost: {
      bg: null,
      fg: 'color.primary',
      radius: 10,
      padding: { top: 12, end: 16, bottom: 12, start: 16 },
    },
  },
};
